export function FiltersSkeleton() {
  return (
    <div className="animate-pulse rounded-lg border border-gray-200 bg-white p-4">
      {/* Title */}
      <div className="mb-4 h-6 w-20 rounded bg-gray-200" />

      {/* First filter section - Price */}
      <div className="border-b border-gray-200 py-3">
        <div className="mb-3 flex items-center justify-between">
          <div className="h-4 w-10 rounded bg-gray-200" />
          <div className="h-4 w-4 rounded bg-gray-200" />
        </div>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="h-4 w-12 rounded bg-gray-200" />
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-12 rounded bg-gray-200" />
          </div>
          <div className="h-1.5 w-full rounded-full bg-gray-200" />
          <div className="flex items-center justify-between">
            <div className="h-3 w-16 rounded bg-gray-200" />
            <div className="h-3 w-16 rounded bg-gray-200" />
          </div>
        </div>
      </div>

      {/* Second filter section - Stops */}
      <div className="border-b border-gray-200 py-3">
        <div className="mb-3 flex items-center justify-between">
          <div className="h-4 w-16 rounded bg-gray-200" />
          <div className="h-4 w-4 rounded bg-gray-200" />
        </div>
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-24 rounded bg-gray-200" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-28 rounded bg-gray-200" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-32 rounded bg-gray-200" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-36 rounded bg-gray-200" />
          </div>
        </div>
      </div>

      {/* Third filter section - Companies */}
      <div className="border-b border-gray-200 py-3">
        <div className="mb-3 flex items-center justify-between">
          <div className="h-4 w-24 rounded bg-gray-200" />
          <div className="h-4 w-4 rounded bg-gray-200" />
        </div>
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-24 rounded bg-gray-200" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-38 rounded bg-gray-200" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-32 rounded bg-gray-200" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-28 rounded bg-gray-200" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-36 rounded bg-gray-200" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-28 rounded bg-gray-200" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-36 rounded bg-gray-200" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-24 rounded bg-gray-200" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200" />
            <div className="h-4 w-30 rounded bg-gray-200" />
          </div>
        </div>
      </div>

      {/* Reset button skeleton */}
      <div className="mt-4 border-t border-gray-200 pt-4">
        <div className="h-9 w-full rounded bg-gray-200" />
      </div>
    </div>
  )
}
